module.exports = __webpack_public_path__ + "img/light-logo.47b66ca7.png";